import * as services from "./default-http-services";

window["QuickSoft"] = (function(ns) 
{
    if (!ns.Signer) ns.Signer = { }; 
    let signerNS = ns.Signer;

    signerNS.DefaultSignerSessionHttpServices = services.DefaultSignerSessionHttpServices;

    return ns;
})(window["QuickSoft"] || {});



// WEBPACK FOOTER //
// ./lib/index-http.ts